import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import UpgradePlanButton from '@features/Paywall/UpgradePlanButton';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import usePermissions from '@hooks/usePermissions';
import { SurveysIcon } from 'assets/images/icons';

const Container = styled(Paper)({
    padding: 24,
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
    gap: 16,
    '@media (max-width: 1024px)': {
        padding: 16,
    },
    '@media (max-width: 820px)': {
        flexDirection: 'column',
    },
});

const ContentWrapper = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '@media (max-width: 820px)': {
        alignItems: 'center',
        textAlign: 'center',
    },
});

const SurveysDisabled = () => {
    const { t } = useTranslation();
    const { isOwner, hasFullSettings } = usePermissions();
    const canUpgradePlan = isOwner || hasFullSettings();

    return (
        <Container>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <SurveysIcon />
            </div>
            <ContentWrapper>
                <Typography variant="subtitle2">{t('HomePage.surveysTitle')}</Typography>
                <Typography variant="caption" color="textSecondary">
                    {t('FeedbackSurveys.subtitle')}
                </Typography>
                {canUpgradePlan ? <UpgradePlanButton style={{ width: 'fit-content' }} /> : null}
            </ContentWrapper>
        </Container>
    );
};

export default SurveysDisabled;
